import { machine, connect } from '@zag-js/collapsible';
import { useMachine } from '@zag-js/svelte';
import { useConnect } from '../../utils/useConnect.svelte.js';
export const useCollapsible = (props) => {
    const service = useMachine(machine, props);
    return useConnect(service, connect);
};
